__turbopack_context__.v({
  "className": "apercubold_43c3016a-module__b7fS7G__className",
  "variable": "apercubold_43c3016a-module__b7fS7G__variable",
});
